import React from "react";
import {
     FormGroup,
} from "reactstrap";
import SelectBox from "../../components/Inputs/SelectBox";

const DeviceSubscription = ({ setValue, value, }) => {
    const deviceNumberChange = (selectedOption) => {
        setValue(selectedOption.value);
    }

    const options = []
    for (let i = 1; i <= 99; i++) {
        options.push({ value: i, label: i })
    }

    return (
        <>
            <FormGroup row className="">
                <SelectBox id="NumberOfDevices" selectionChange={deviceNumberChange} options={options} label="Number of Devices:" />
            </FormGroup>
            <FormGroup row>
                <p>Number of Licenses Available: {value}</p>
            </FormGroup>
            <FormGroup row className="bg-light p-3">
                {value} Licenses ($15 / each - per month) = <b className="ml-1">Total:</b> <span className="bg-white mx-2 px-1"> <b>${15 * value}</b> / month </span>
            </FormGroup>
        </>
    )
}

export default DeviceSubscription
